
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, computed, watch } from 'vue'
import { ClockCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import Descriptions from '@/components/descriptionsLhl.vue'
import api from '@/api/allApi'
import Nodata from '@/components/page/nodata.vue'
import globalsets from '@/utils/globalsets'

import f10ApiHk from '@/api/f10ApiHk'
import f10ApiUS from '@/api/f10ApiUS'
import { isLocalDev } from '@/api/config'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { ClockCircleOutlined, Descriptions, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      list: [],
      opencontent1: false,
      opencontent2: false,
      open1: false,
      open2: false,
      info: {},
      spinning: true
    })
    pageData.list = [
      { title: '上市日期', key: 'listedDate', align: 'left' },
      { title: '所属市场', key: 'tradeMarket', align: 'left' },

    ]


    onMounted(() => {
      const route: any = useRoute()
      const market = isLocalDev ? 'NASDAQ' : (route.query.market as string)
      const symbol = isLocalDev ? 'AAPL' : (  route.query.code   as string)

      const data = {
        data: {
          market,
          symbol,
        },
        headers: {
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
        }
      }
      f10ApiUS.getZjzl(data).then((res: any) => {
        if (res && res.data) {
          const raw = res.data
          // 处理后的数据
          const info: any = {
            listedDate: raw.listedDate ? window.moment(raw.listedDate).format('YYYY-MM-DD') : '—', // 上市日期
            tradeMarket: raw.tradeMarket || '—', // 所属市场
          }
          pageData.info = info
          pageData.spinning = false
          pageData.spinning = false
        }

      })


    })
    // watch(
    //   () => props.pageSourceData,
    //   () => {
    //     const _data = props.pageSourceData || {}
    //     _data.ProvinceCity = _data.Province + _data.City
    //     _data.RegCapital = _data.RegCapital = globalsets.getNumber(_data.RegCapital)
    //     pageData.info = _data
    //     nextTick(() => {
    //       pageData.spinning = false
    //     })
    //   },
    //   { deep: true }
    // )
    return {
      ...toRefs(pageData)
    }
  }
})
